<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Report Tools Asesmen",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
  },
  data() {
    return {
      title: "Report Tools Asesmen",
      loadingTableTools: true,
      loadingTablePenyusun: true,
      listKetersediaanTools: [],
      listKetersediaanPenyusun: [],
      columnKetersediaanTools: [
        { width: "40%", label: "Level", name: "-" },
        { width: "20%", label: "Ada", name: "-" },
        { width: "20%", label: "Tidak Ada", name: "-" },
        { width: "20%", label: "%", name: "-" },
      ],
      columnKetersediaanPenyusun: [
        { width: "40%", label: "Penyusun", name: "-" },
        { width: "10%", label: "1.Knowledgeable", name: "-" },
        { width: "10%", label: "2.Practitioner", name: "-" },
        { width: "10%", label: "3.Advandced", name: "-" },
        { width: "10%", label: "4.Mastery", name: "-" },
        { width: "10%", label: "%", name: "-" },
        { width: "10%", label: "Total", name: "-" },
      ],
      levelLabel: [],
      penyusunLabel: [],
      levelChartOption: [],
      levelChartSeries: [],
      penyusunChartOption: [],
      penyusunChartSeries: [],
    };
  },
  methods: {
    async getLevelChart() {
      this.loadingTableTools = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/ketersediaan-tools`,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data ketersediaan tools",
          });
          console.log(response.data);
          return;
        }

        this.listKetersediaanTools = response.data.data.list;
        this.levelChartSeries = response.data.data.series;
        this.levelLabel = response.data.data.label;
        this.loadingTableTools = false;
        this.setLevelGraph();
      });
    },
    setLevelGraph() {
      this.levelChartOption = {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Ketersediaan Tools Berdasarkan Level Profisiensi",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.levelLabel,
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
    async getPenyusunChart() {
      this.loadingTablePenyusun = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/ketersediaan-penyusun`,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data ketersediaan penyusun",
          });
          console.log(response.data);
          return;
        }

        this.listKetersediaanPenyusun = response.data.data.list;
        this.penyusunChartSeries = response.data.data.series;
        this.penyusunLabel = response.data.data.label;
        this.loadingTablePenyusun = false;
        this.setPenyusunGraph();
      });
    },
    setPenyusunGraph() {
      console.log(this.penyusunLabel);
      this.penyusunChartOption = {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Ketersediaan Tools Berdasarkan Penyusun",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.penyusunLabel,
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
  },
  mounted() {
    this.getLevelChart();
    this.getPenyusunChart();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Level Profisiensi</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnKetersediaanTools">
                <tbody>
                  <tr v-if="loadingTableTools">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listKetersediaanTools.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listKetersediaanTools"
                    :key="key"
                  >
                    <td>{{ row.level }}</td>
                    <td class="text-center">{{ row.ada }}</td>
                    <td class="text-center">{{ row.tidak_ada }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="levelChartSeries.length > 0"
                  class="apex-charts"
                  :options="levelChartOption"
                  :series="levelChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Penyusun</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnKetersediaanPenyusun">
                <tbody>
                  <tr v-if="loadingTablePenyusun">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listKetersediaanPenyusun.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listKetersediaanPenyusun"
                    :key="key"
                  >
                    <td>{{ row.penyusun }}</td>
                    <td class="text-center">{{ row['1.Knowledgeable'] }}</td>
                    <td class="text-center">{{ row['2.Practitioner'] }}</td>
                    <td class="text-center">{{ row['3.Advanced'] }}</td>
                    <td class="text-center">{{ row['4.Mastery'] }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                    <td class="text-center">{{ row.total }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div>
                <apexchart
                  v-if="penyusunChartSeries.length > 0"
                  class="apex-charts"
                  :options="penyusunChartOption"
                  :series="penyusunChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
